import { render } from "./SuccessRegisterPage.vue?vue&type=template&id=652a1c1a&scoped=true"
import script from "./SuccessRegisterPage.vue?vue&type=script&lang=js"
export * from "./SuccessRegisterPage.vue?vue&type=script&lang=js"

import "./SuccessRegisterPage.vue?vue&type=style&index=0&id=652a1c1a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-652a1c1a"]])

export default __exports__